import { useRef } from 'react';

import axios from 'axios';
import { useMutation, useQuery } from 'react-query';

import { useUserContext } from '@/context/user-context';

export const useNewCGU = ({ params, ...config } = {}) => {
  const alreadyDoGet = useRef(false);
  const { user: currentUser } = useUserContext();
  return useQuery(
    ['CGU', params],
    () => {
      if (currentUser !== null) {
        // évite une rêquete si non connecté
        if (!alreadyDoGet.current) {
          // Vérifier si la requête a déjà été effectuée
          alreadyDoGet.current = true;
          return axios.get('/termsAndConditions', { params });
        }
      }
      return false;
    },
    config
  );
};

export const useNewCurrentDateCGU = (config) =>
  useMutation((values) => axios.post('/termsAndConditions', values), config);
